import { render, staticRenderFns } from "./NpsAnswer.vue?vue&type=template&id=ff7dceda&scoped=true"
import script from "./NpsAnswer.vue?vue&type=script&lang=js"
export * from "./NpsAnswer.vue?vue&type=script&lang=js"
import style0 from "./NpsAnswer.vue?vue&type=style&index=0&id=ff7dceda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7dceda",
  null
  
)

export default component.exports